import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { api, setCsrfToken } from './api';
import { AdminLayout } from './AdminLayout';

export function AdminGuard() {
  const [state, setState] = useState({ loading: true, user: null });
  const location = useLocation();

  useEffect(() => {
    let active = true;
    api('/auth/me')
      .then((data) => {
        if (!active) return;
        setCsrfToken(data.csrf_token);
        setState({ loading: false, user: data.user });
      })
      .catch(() => {
        if (active) setState({ loading: false, user: null });
      });
    return () => { active = false; };
  }, [location.pathname]);

  if (state.loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-brand-cream" role="status">
        <p className="text-brand-brown-soft">Anmeldung wird geprüft …</p>
      </div>
    );
  }
  if (!state.user) return <Navigate to="/admin" replace />;
  return (
    <AdminLayout user={state.user}>
      <Outlet />
    </AdminLayout>
  );
}
